import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ShoppingCart, Users, TrendingUp } from "lucide-react";
export const HowItWorksSection = () => {
  return <section className="py-12 md:py-16 lg:py-[60px] bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white mb-4">Como multiplicar suas vendas</h2>
          <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto px-4">
            Processo simples em 3 passos para transformar clientes em vendedores
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          <Card className="text-center border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 p-4 md:p-6">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-brand-teal to-brand-coral rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <ShoppingCart className="h-6 w-6 md:h-8 md:w-8 text-white" />
              </div>
              <CardTitle className="text-lg md:text-xl text-gray-900 dark:text-white">1. Configure Cashback</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm md:text-base text-gray-600 dark:text-gray-300">
                Defina regras de cashback automático para cada compra. Seus clientes ganham dinheiro de volta e você garante a fidelização.
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="text-center border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 p-4 md:p-6">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-brand-coral to-brand-teal rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <Users className="h-6 w-6 md:h-8 md:w-8 text-white" />
              </div>
              <CardTitle className="text-lg md:text-xl text-gray-900 dark:text-white">2. Ative Indicações</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm md:text-base text-gray-600 dark:text-gray-300">
                Transforme clientes em vendedores. Cada indicação gera comissão para quem indica e desconto para o novo cliente.
              </CardDescription>
            </CardContent>
          </Card>

          <Card className="text-center border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 p-4 md:p-6">
            <CardHeader className="pb-4">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gradient-to-r from-brand-teal to-brand-coral rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
                <TrendingUp className="h-6 w-6 md:h-8 md:w-8 text-white" />
              </div>
              <CardTitle className="text-lg md:text-xl text-gray-900 dark:text-white">3. Veja Resultados</CardTitle>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm md:text-base text-gray-600 dark:text-gray-300">
                Acompanhe o crescimento exponencial: mais vendas, clientes fiéis e uma rede de indicações que vende para você.
              </CardDescription>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
};